var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.201 18.4386C23.2643 18.4386 26.5582 15.1446 26.5582 11.0813C26.5582 7.01806 23.2643 3.72412 19.201 3.72412C15.1377 3.72412 11.8438 7.01806 11.8438 11.0813C11.8438 15.1446 15.1377 18.4386 19.201 18.4386Z",
    fill: "url(#paint0_linear_1694_4562)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 31.8887H31.8902V33.4831H23.918V31.8887Z",
    fill: "url(#paint1_linear_1694_4562)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.082 34.1664V37.5831C17.082 37.8852 17.202 38.1748 17.4156 38.3884C17.6292 38.602 17.9188 38.722 18.2209 38.722H37.582C37.8841 38.722 38.1737 38.602 38.3873 38.3884C38.6009 38.1748 38.7209 37.8852 38.7209 37.5831V26.1942C38.7209 25.8922 38.6009 25.6025 38.3873 25.3889C38.1737 25.1753 37.8841 25.0553 37.582 25.0553H29.6098V23.3812C29.6098 23.0791 29.4898 22.7894 29.2762 22.5759C29.0626 22.3623 28.7729 22.2423 28.4709 22.2423C28.1688 22.2423 27.8792 22.3623 27.6656 22.5759C27.452 22.7894 27.332 23.0791 27.332 23.3812V25.0553H25.0542V20.9781C23.119 20.6614 21.1613 20.5015 19.2003 20.4998C14.8757 20.4814 10.5996 21.4105 6.67256 23.2217C6.02622 23.5267 5.48095 24.0108 5.10143 24.6164C4.72192 25.222 4.5241 25.9237 4.53145 26.6384V34.1664H17.082ZM36.4431 36.4442H19.3598V27.3331H27.332V27.8114C27.332 28.1135 27.452 28.4032 27.6656 28.6168C27.8792 28.8303 28.1688 28.9503 28.4709 28.9503C28.7729 28.9503 29.0626 28.8303 29.2762 28.6168C29.4898 28.4032 29.6098 28.1135 29.6098 27.8114V27.3331H36.4431V36.4442Z",
    fill: "url(#paint2_linear_1694_4562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1694_4562",
    x1: 11.8438,
    y1: 1.88482,
    x2: 27.5301,
    y2: 19.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1694_4562",
    x1: 23.918,
    y1: 31.6894,
    x2: 24.5212,
    y2: 34.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1694_4562",
    x1: 4.53125,
    y1: 18.2217,
    x2: 19.8809,
    y2: 49.7656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer3);
export default __webpack_public_path__ + "static/media/Offer3.c1eefdf440ccfb24807022d9becb4d78.svg";
export { ForwardRef as ReactComponent };